import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../components/Icon';

import messages from './messages';
import './styles.css';

const MenuHeader = ({ menuType, onGoback }) => (
  <div styleName="menu-header">
    <div styleName="go-back-container">
      <button styleName="go-back-button" type="button" onClick={onGoback}>
        <Icon name="angle left" />
      </button>
      <h2 styleName="title">
        <FormattedMessage {...messages[menuType]} />
      </h2>
    </div>
    <FormattedMessage {...messages.choose} />
  </div>
);

MenuHeader.propTypes = {
  menuType: PropTypes.string,
  onGoback: PropTypes.func,
};

export default MenuHeader;
